import { useCallback } from 'preact/hooks';
import { useBlockStore } from '../stores/BlockStore';
import { useFormStore } from '../stores/FormStore';

export default function useResetForm() {
	const formStore = useFormStore();
	const blockStore = useBlockStore();

	return useCallback(() => {
		blockStore.actions.reset();
		formStore.actions.reset();
	}, []);
}
